import React, { Component } from 'react';
import AdminHeaderView from './AdminHeaderView';
import { url } from '../../../Server/url/GlobalUrl';


class AdminHeaderComponent extends Component {

    state = {
        html_menu: 'sidebar',
        first_name: '',
        last_name: '',
        id:''
    }

    showMenuBar = (event) => {
        this.setState({
            ...this.state,
            html_menu: 'sidebar active'
        })
    }

    closeMenuBar = (event) => {
        this.setState({
            ...this.state,
            html_menu: 'sidebar'
        })
    }
    componentDidMount() {
        console.log('I am in',localStorage.getItem("token"))
        if (localStorage.getItem("token")){
        let data_refresh = {'refresh': localStorage.getItem('refresh')}
      fetch(url + '/api/token/refresh/', {
            method: 'POST',
            headers: {
               'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data_refresh)
        })
            .then((response) => {
             if (response['status'] === 201 || response['status'] === 200) {
                return response.json()
            } else if (response['status'] === 401) {
                // this.showCustomModal()
                this.setState({authResponse:'Some Thing went wrong'})
                localStorage.removeItem('refresh')
                localStorage.removeItem('access')
                localStorage.removeItem('is_admin')
            }
            })
            .then((result) => {
                if (result){
                console.log('result.access',result.access)
                localStorage.setItem('token',result.access)
                }
            }
            )
        let auth = localStorage.getItem('token')
        fetch((url + "/api/current/?token="+ localStorage.getItem("invalid")), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + auth,
                },
                })
              .then(res => res.json())
              .then(
                (result) => {
                console.log('result',result)
                if (result.detail != 'Given token not valid for any token type'){
                    if (result){
                  console.log('result',result, result.first_name)
                  this.setState({ first_name: result.first_name })
                  this.setState({ last_name: result.last_name })
                  this.setState({ id: result.id })
                  localStorage.setItem('cv-id',result.id)
                  console.log('asdasd',this.state.first_name)
                 }
                else{
//                    localStorage.removeItem('token')
//                    localStorage.removeItem('refresh')
//                    localStorage.removeItem('is_applicant')
//                    localStorage.removeItem('is_admin')
//                    localStorage.removeItem('is_candidate')
                    localStorage.removeItem('is_pre_screen_applicant')
                }


              }
              else{
                localStorage.removeItem('token');
                localStorage.removeItem('refresh')
                localStorage.removeItem('is_applicant')
                localStorage.removeItem('is_admin')
                localStorage.removeItem('is_candidate')
                localStorage.removeItem('is_pre_screen_applicant')
                window.location.reload();
              }
                },
                (error) => {
                  console.log('error',error)
                })
                }

        }

    handlelogout = () => {
        console.log('hello all')
        localStorage.removeItem('token')
        localStorage.removeItem('refresh')
        localStorage.removeItem('is_applicant')
        localStorage.removeItem('is_admin')
        localStorage.removeItem('is_candidate')
        localStorage.removeItem('is_pre_screen_applicant')
    	window.location.replace('/login')
    }

    render() {
        return (
            <AdminHeaderView
                handlelogout = {this.handlelogout}
                sticky={this.props.sticky}
                manuClass={this.state.html_menu}
                showMenuBar={this.showMenuBar}
                closeMenuBar={this.closeMenuBar}
                first_name={this.state.first_name}
                id={this.state.id}
                last_name = {this.state.last_name}
            />
        )
    }
}

export default AdminHeaderComponent;
